const EMOJI_RE = /\p{Extended_Pictographic}/u;
 
// Any Unicode "letter" that is NOT part of the Latin script. This catches
// Telugu, Hindi (Devanagari), Tamil, and every other non-English script,
// while still allowing accented Latin letters (é, ñ, ü) used in English text.
const LETTER_RE = /\p{L}/gu;
const LATIN_LETTER_RE = /\p{Script=Latin}/u;
 
export function containsEmoji(text) {
  return EMOJI_RE.test(String(text || ""));
}
 
export function containsNonEnglish(text) {
  const letters = String(text || "").match(LETTER_RE) || [];
  return letters.some((ch) => !LATIN_LETTER_RE.test(ch));
}
 
export function validateIntakeText(text) {
  const trimmed = String(text || "").trim();
  if (!trimmed) {
    return { ok: false, message: "Response cannot be empty." };
  }
  if (containsEmoji(trimmed)) {
    return { ok: false, message: "Emojis are not allowed in intake responses." };
  }
  if (containsNonEnglish(trimmed)) {
    return {
      ok: false,
      message: "Only English responses are accepted. Please remove non-English characters.",
    };
  }
  return { ok: true, value: trimmed };
}
